module.exports = __webpack_public_path__ + "static/media/plus-round.6bf1e1ce.svg";